<template>
  <v-app>
    <v-container class="appclick">
      <Header>
        <font-awesome-icon :icon="['fas', 'eye']" />
        <span class="title">Summary</span>
      </Header>
      <v-row>
        <v-col class="col-6">
          <img class="foto" :src="field.foto" />
          <v-row class="teksten">
            <v-col class="col-3">
              <b>Creation</b><br />
              Author<br />
              Created<br />
              Changed<br /><br />
              <b>Video quality</b><br />
              Width<br />
              Height<br />
              Frame per second<br /><br />
              <b>Settings minimal<br />hard recognition</b><br />
              Frames per object<br />
              Screen distance<br />
              Confidence<br /><br />
            </v-col>
            <v-col class="col-3"
              ><br />
              [[Naam]]<br />
              {{ field.created }}<br />
              {{ field.changed }}<br /><br /><br />
              {{ field.field_video_width }} pixels<br />
              {{ field.field_video_height }} pixels<br />
              {{ field.field_fps }}<br /><br /><br /><br />
              {{ field.field_fpo }}<br />
              {{ field.field_distance }}<br />
              {{ field.field_confidence }}<br />
            </v-col>
            <v-col class="col-3">
              <b>Content</b><br />
              Cam<br />
              Date<br />
              Duration<br /><br /><br /><br /><br /><br /><br />
              <b>Settings maximum<br />loose ends</b><br />
              Timespan<br />
              Distance
            </v-col>
            <v-col class="col-3">
              <br />{{ field.field_camera }} <br />{{ field.field_periode
              }}<br />
              <br /><br /><br /><br /><br /><br />
              <br />
              {{ field.field_loosea_time }}<br />
              {{ field.field_loosea_distance }}
            </v-col>
          </v-row>
        </v-col>
        <v-col class="col-6"></v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import Header from "@/components/Header.vue";
import ProjectService from "@/services/ProjectService.js";
export default {
  components: {
    Header
  },
  mounted() {
    this.GetApi();
  },
  methods: {
    GetApi() {
      ProjectService.apiGet({
        nid: this.$session.get("PROJID"),
        type: "summary"
      })
        .then(response => {
          this.field = response.data.fields;
        })
        .catch(error => {
          console.log("Fout " + error.response);
        });
    }
  },
  data() {
    return {
      field: {},
      img_figuren: "./assets/images/figuren.jpg"
    };
  }
};
</script>
<style scoped>
.tabel {
  background-color: azure;
}
::v-deep .tabel td,
::v-deep .tabel th {
  border-style: solid;
  border-width: thin;
  text-align: center;
}

.middle {
  margin-top: 30%;
}
.teksten {
  font-size: 90%;
}
.foto {
  width: 95%;
}
</style>
